import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { Outlet } from 'react-router-dom';

import { SettingsSidebar } from '@/features/settings';
import { Header } from '@/layouts/components/header';

// Authenticated chrome for `/settings/*`. Header on top; on md+ a 240px sidebar holds
// the section nav with the active page in the right column. On xs the sidebar stacks
// above the content for now (will be replaced with a tabbed top-bar when the design lands).
export function SettingsLayout() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'background.default',
      }}
    >
      <Header />
      <Container
        maxWidth="lg"
        sx={{
          flex: 1,
          py: { xs: 3, md: 5 },
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '240px 1fr' },
          gap: { xs: 3, md: 5 },
          alignItems: 'start',
        }}
      >
        <SettingsSidebar />
        <Box>
          <Outlet />
        </Box>
      </Container>
    </Box>
  );
}
